import { ToJsonWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ToJson')
export class ToJsonNodeSchemaProvider extends SchemaProvider<ToJsonWorkflowNode> {}
